import img1 from '../Images/bike_image1.jpg';
import img2 from '../Images/bike_image2.webp';
import img3 from '../Images/bike_image3.jfif';
import img4 from '../Images/book_image1.jfif';
import img5 from '../Images/book_image2.jfif';
import img6 from '../Images/book_image3.jfif';
import img7 from '../Images/lap_image1.jfif';
import img8 from '../Images/lap_image2.jfif';
import img9 from '../Images/lap_image3.jfif';



const data = {
    productData:[
       
        {
            id:3,
            img:img3,
            title:'Pulsar',
            desc:'A pulsar is a highly magnetized rotating compact star With an awesome metallic black finish and an excellent customised look',
            price:40000,
        },
        {
            id:20,
            img:img8,
            title:'Dell Vostro 15 350',
            desc:'10th Generation Intel® Core™ i3-1005G1 Processor (4MB Cache, up to 3.4 GHz) laptop Windows 10 Home Single Language, English Intel® UHD Graphics',
            price:35500,
        },
        {
            id:10,
            img:img4,
            title:'Physical Science',
            desc:'Physical science is the study of the inorganic world. That is, it does not study living things, which include meteorology and geology',
            price:500,
        },
        
        {
            id:12,
            img:img6,
            title:'Living Planet',
            desc:'In The Living Planet, based on his BBC television series, David Attenbouroughs searching eye good for nature lovers who wish to explore the world ',
            price:400,
        },
        {
            id:2,
            img:img2,
            title:'Hero Pleasure Plus Platinum',
            desc:'It is powered by 110.9 cc engine and puts a power of 8.1 PS sleek design easy to handle with an amazing colour finish',
            price:70000,
        },
        {
            id:21,
            img:img9,
            title:'Apple MacBook Pro',
            desc:'Apple MacBook Pro is a macOS laptop with a 13.30-inch display that has a resolution of 2560x1600 pixels.',
            price:40000,
        },
        {
            id:19,
            img:img7,
            title:'HP Pavilion x360',
            desc:'HP Pavilion x360 14-dh1011tu 8GB02PA#ACJ Core i5 10th Gen Windows 10 Home Laptop (8 GB RAM, 1 TB HDD + 256 GB SSD, Intel UHD Graphics, 35.56cm, Natural Silver)',
            price:64000,
        },
        
        {
            id:11,
            img:img5,
            title:'Oxford Dictionary',
            desc:'A dictionary is a reference book about words and as such it describes the functioning of individual words',
            price:200,
        },
        {
            id:1,
            img:img1,
            title:'Duke 250',
            desc:'Engine Displ: 248.8 cc Max Power: 30 PS @ 9000 rpm Mileage: 41 kmpl Fuel Type: Petrol helps youbto rule the road and in amazing condition',
            price:50000,
        },
    ],
};

export default data;